<template>
  <a-card class="m-t-10" :bordered='false'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <!-- 卡卷类型（ 1：折扣券 2：现金券 3：代金券） -->
    <span class="ml15 card_title">{{$route.query.type == 'add' ? '添加':'编辑'}}{{form.coupon_type == 1 ? '折扣券':(form.coupon_type == 2 ? '现金券':'代金券')}}</span>
    <SmallSquare v-if='form.coupon_type == 1' class="m-t-24" content='折扣券对全店商品或指定商品有效，同一时段可存在多个代金券，同一订单最多使用一张代金券或折扣券' :padding='false'></SmallSquare>
    <SmallSquare v-if='form.coupon_type == 2' class="m-t-24" content='现金券对全店商品有效，同一时段可存在多个现金券，同一订单最多使用一张现金券' :padding='false'></SmallSquare>
    <SmallSquare v-if='form.coupon_type == 3' class="m-t-24" content='代金券对全店商品或指定商品有效，同一时段可存在多个代金券，同一订单最多使用一张代金券或折扣券' :padding='false'></SmallSquare>
  </a-card>
  <a-card :bordered='false'>
    <app-warp title='优惠券' color='#efefef'>
      <template #app-content>
        <div class="p-10">
          <div class="couponBox s_bf width100 s_po_re ">
            <div class="coupon_one ptb-20">
              <p class="fz-12 s_c666 p-t-20 text-ac">{{form.name || '这里显示优惠券名称'}}</p>
              <p class="ptb-20 s_c333 text-ac fz-18"><span class="fz-40 s_font_b">{{form.amount || 0}}</span>{{form.coupon_type == 1?'折':'元'}}</p>
              <p class="fz-12 s_c666 p-b-10 text-ac" v-if='form.use_condition == 1'>满{{form.limit_amount || 'X'}}元可用</p>
              <p class="fz-12 s_c666 p-b-10 text-ac" v-else>无门槛</p>
              <p class="fz-12 s_c999 text-ac" v-if='form.valid_period == 2'>有效期：{{time.length ? time[0] : 'XXXX-XX-XX'}}至{{time.length ? time[1] : 'XXXX-XX-XX'}}</p>
              <p class="fz-12 s_c999 text-ac" v-else>有效期：领取日起 {{form.valid_days || 'X'}} 天内</p>
              <p class="width45 height-40 s_flex_center m-t-20 m-b-5 s_cfff fz-16 bor-rad-3 s_mauto"
                style="background: #ff7e28;">立即使用</p>
              <p class="ban left"></p>
              <p class="ban right"></p>
            </div>
            <div class="coupon_two p-tb0-lr10">
              <p class="height-51 s_bor_b_cd9 s_flex_bian_c s_c666 fz-13" style="border-color: #f0f0f0;">
                适用商品：{{form.with_product_type == 1 ? "全部商品":"部分商品"}}</p>
              <p class="height-46 s_bor_b_cd9 s_flex_bian_c s_c333 fz-13" style="border-color: #f0f0f0;">在线云店
                <RightOutlined />
              </p>
              <p class="s_c666 p-t-15 p-b-15 fz-13">{{form.explain || '使用说明'}}</p>
            </div>
          </div>
        </div>
      </template>
      <template #app-sider>
        <!-- 卡卷类型（ 1：折扣券 2：现金券 3：代金券） -->
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" style="margin-left:25px">
          <!-- 基本信息 -->
          <div class="mb25">
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 m-b-20">优惠券信息</p>
            <a-form-item ref="name" label="优惠券名称" name="name" help=''>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input v-model:value="form.name" placeholder='请输入名称' :maxlength='10' :suffix="form.name.length+'/10'" />
                </a-col>
                <a-col :span="12">
                  <p>限10个字内</p>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="" label="优惠券类型" name="" help=''>
              <span>{{form.coupon_type == 1 ? '折扣券':(form.coupon_type == 2 ? '现金券':'代金券')}}</span>
            </a-form-item>
            <a-form-item ref="amount" :label="form.coupon_type == 1?'折扣':'面值'" name="amount" :help='form.coupon_type == 3 ? "（面值需小于订单金额）":""'>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-input-number class="width100" v-model:value="form.amount" :disabled="$route.query.type == 'edit'" :min='0' :max='form.coupon_type == 1 ? 9.9:999999' :precision='form.coupon_type == 1 ? 1:2' placeholder='请输入' />
                </a-col>
                <a-col :span="12">
                  <p v-if='form.coupon_type == 1'>折<span class="s_c999">（1折=10%折扣，输入数字需小于10）</span></p>
                  <p v-else>元</p>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="use_condition" label="使用条件" name="use_condition" v-if='form.coupon_type == 3'>
              <a-radio-group v-model:value="form.use_condition" @change="changeCondition" :disabled="$route.query.type == 'edit'">
                <a-radio :value="0">
                  <span class="s_c333">无门槛</span>
                </a-radio>
                <a-radio :value="1">
                  <span class="s_c333">
                    订单金额满
                    <a-input-number class="width-150 m-l-10 m-r-10" style='display: inline-block;'
                      :disabled='form.use_condition !== 1 || $route.query.type == "edit"'
                      v-model:value="form.limit_amount" :min='0' :precision='2' placeholder='请输入金额' />
                    元可用
                  </span>
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <div class="mb25">
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 m-b-20">优惠券规则</p>
            <a-form-item ref="valid_period" label="有效期" name="valid_period" style="margin-bottom: 0;">
              <a-radio-group v-model:value="form.valid_period" :disabled="$route.query.type == 'edit'" @change="changDate">
                <a-radio :value="1">
                  <span class="s_c333">
                    自领取日，有效
                    <a-input-number class="width-150 m-l-10 m-r-10" style='display: inline-block;'
                      :disabled="form.valid_period !== 1 || $route.query.type == 'edit'"
                      v-model:value="form.valid_days" :min='0' :max='30' :precision='0' placeholder='请输入天数' />
                    天
                  </span>
                </a-radio>
                <p class="s_c999 m-l-20 m-t-15 m-b-15">（有效期天数最多30天，适用于活动周期较长的活动）</p>
                <a-radio :value="2">
                  <span class="s_c333 m-r-15">自定义有效期</span>
                  <a-range-picker 
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [momentTime('HH:mm:ss'), momentTime('23:59:59', 'HH:mm:ss')],
                    }"
                    :disabled-date="disabledDate"
                    format="YYYY-MM-DD HH:mm:ss"
                    valueFormat='YYYY-MM-DD HH:mm:ss' 
                    v-if='form.valid_period == 2' 
                    :disabled="$route.query.type == 'edit'"
                    v-model:value="time" />
                </a-radio>
                <p class="s_c999 m-l-20 m-t-15 m-b-15">（适用于特殊节日，所选时间不能选择过去时间）</p>
              </a-radio-group>
            </a-form-item>
            <a-form-item ref="with_product_type" label="适用商品" name="with_product_type" v-if='form.coupon_type != 2'>
              <a-radio-group v-model:value="form.with_product_type" :disabled="$route.query.type == 'edit'">
                <a-radio :value="1">
                  <span class="s_c333">全部商品</span>
                </a-radio>
                <a-radio :value="2">
                  <span class="s_c333">适用部分商品</span>
                </a-radio>
                <a-radio :value="3">
                  <span class="s_c333">排除部分商品</span>
                </a-radio>
              </a-radio-group>
              <div class="m-b-15" v-if='form.with_product_type == 2 || form.with_product_type == 3'>
                <a-button type="primary" @click='showGood = true' :disabled="$route.query.type == 'edit'">选择商品</a-button>
              </div>
              <a-table :pagination='false' :loading='listLoading' bordered rowKey='product_id' :columns='columns' :data-source='goodList' v-if='goodList.length'>
                <template v-slot:info="{record}">
                  <a-card-meta>
                    <template #avatar>
                      <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt=""
                        style="width:50px;height: 50px;object-fit:cover">
                    </template>
                    <template #description>{{record.product_name}}</template>
                  </a-card-meta>
                </template>
                <template v-slot:action="{ record }">
                  <a-button type="link" @click='delGood(record)' :disabled="$route.query.type == 'edit'">删除</a-button>
                </template>
              </a-table>
            </a-form-item>
            <a-form-item ref="explain" label="使用说明" name="explain" style="margin-bottom: 0;">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-textarea v-model:value="form.explain" showCount :maxlength="300" placeholder="请输入使用说明"
                    :rows="4" />
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item ref="remark" label="备注" name="remark" help="不在前端显示，方便工作人员对优惠券进行关联" style="margin-bottom: 0;">
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-textarea v-model:value="form.remark" showCount :maxlength="20" placeholder="请输入备注" :rows="4"/>
                </a-col>
              </a-row>
            </a-form-item>
          </div>
          <div class="mb25" v-if="$route.query.type == 'edit'">
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 m-b-20">优惠券状态</p>
            <a-form-item ref="status" label="状态" name="status">
              <a-radio-group v-model:value="form.status">
                <a-radio :value="1">生效</a-radio>
                <a-radio :value="0">失效</a-radio>
              </a-radio-group>
              <a-tooltip placement='right'>
                <template #title>禁用进行中的优惠券会影响会员正常购买，建议您提前告知或说明。</template>
                <QuestionCircleOutlined class="s_c376" />
              </a-tooltip>
            </a-form-item>
          </div>
          <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
            <a-button style="width:100px" type="primary" @click="onSubmit">
              保存
            </a-button>
            <a-button style="width:100px" class="m-l-20" @click="$router.go(-1)">
              返回
            </a-button>
          </a-form-item>
        </a-form>
      </template>
    </app-warp>
  </a-card>
  <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='goodList' :checkout="true"></selectGood>
  </a-modal>
</template>
<script>
  import { RightOutlined,LeftOutlined,QuestionCircleOutlined,ExclamationCircleOutlined} from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject,createVNode,h } from 'vue';
  import { newCouponAdd, newCouponEdit, getNewCouponMore } from "@/api/assets";
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import store from "@/store"
  // 初始化默认筛选项数值
  let defForm = {
    name: '',
    coupon_type: '',
    amount: '',
    use_condition: 0,
    limit_amount: '',
    valid_period: 1,
    valid_days: '',
    valid_starts_time:'',
    valid_end_time:'',
    with_product_type:1,
    products: [],
    explain: '',
    remark: '',
    status:1
  }
  export default {
    components: {
      RightOutlined,LeftOutlined,QuestionCircleOutlined
    },
    setup() {
      const $route = inject('$route')
      const $router = inject('$router')
      const _lodash = inject("_lodash");
      const $Modal = inject('$Modal')
      const momentTime = inject("momentTime")
      let use_condition = async () => {
        if (form.value.use_condition == 1 && !isNumber(form.value.limit_amount)) {
          return Promise.reject('请输入金额');
        }else if (form.value.use_condition == 1 && form.value.coupon_type == 3 && (form.value.limit_amount <= form.value.amount)) {
          return Promise.reject('订单金额必须大于面值');
        } else {
          return Promise.resolve();
        }
      };
      let valid_period = async () => {
        if (form.value.valid_period == 1 && (!isNumber(form.value.valid_days) || form.value.valid_days == 0)) {
          return Promise.reject('请输入有效天数或有效天数不能为0');
        }else if (form.value.valid_period == 2 && !state.time.length) {
          return Promise.reject('请选择有效期');
        }else if (form.value.valid_period == 2 && testTime(state.time[0]) < 10 && $route.query.type == 'add') {
          return Promise.reject('有效期开始时间最少需要大于当前时间10分钟');
        }else {
          return Promise.resolve();
        }
      };
      let with_product_type = async () => {
        if (form.value.with_product_type != 1 &&  !state.goodList.length) {
          return Promise.reject('请选择商品');
        } else {
          return Promise.resolve();
        }
      };

      const form = ref({ ...defForm });
      const state = reactive({
        card:'',
        info: store.state.user.info,
        showGood: false,
        goodList: [],
        time: [],
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        rules: {
          name: [
            { required: true, message: '请输入优惠券名称'}
          ],
          amount: [
            { required: true, message: '请输入面值'}
          ],
          use_condition:[
            { required: true, validator: use_condition}
          ],
          valid_period: [
            { required: true, validator: valid_period}
          ],
          with_product_type: [
            { required: true, validator: with_product_type}
          ],
          explain: [
            { required: true, message: '请输入使用说明'}
          ]
        }
      });
      let columns = [
        {
          title: "商品ID",
          dataIndex: "product_id",
          key: "product_id",
        },

        {
          title: "商品信息",
          dataIndex: "info",
          key: "info",
          width:'50%',
          slots: { customRender: "info" },
        },
        {
          title: "库存",
          dataIndex: "stock",
          key: "stock",
        },
        {
          title: "价格/元",
          dataIndex: "product_price",
          key: "product_price",
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          slots: { customRender: "action" },
        },
      ];
      const ruleForm = ref()
      const disabledDate = (current) => {
        return current && current < momentTime().subtract(1, 'days');
      }
      // 判断时间
      const testTime = (time) =>{
        var nowTime = momentTime().format()
        var startTime = momentTime(time)
        return startTime.diff(nowTime, 'minute')
      }

      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      //选择商品
      const goodSelect = (e) => {
        state.goodList = e
        state.showGood = false
      }
      //删除商品
      const delGood = (index) => {
        state.goodList.splice(index, 1)
      }
      //选择有效期
      const changDate = (e) => {
        if (e.target.value == 2) {
          form.value.valid_days = ''
        } else {
          state.time = []
          form.value.valid_starts_time = ''
          form.value.valid_end_time = ''
        }
      }
      //切换使用条件
      const changeCondition = (e) => {
        if (e.target.value == 1) {
          form.value.limit_amount = ''
        }
      }
      //获取详情
      const getMore = async (id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getNewCouponMore({id:id}).then(res => res.data).catch(error => error);
        if (iscode(res)) {
          form.value = res.data
          state.goodList = res.data.product_list
          if(form.value.valid_period == 2){
            state.time = [form.value.valid_starts_time,form.value.valid_end_time]
          }
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      //提交
      const onSubmit = () => {
        ruleForm.value.validate().then(() => {
          if($route.query.type == 'add'){
            addSubmit();
          }
          if($route.query.type == 'edit' && form.value.status){
            confirmSubmit()
          }
          if($route.query.type == 'edit' && !form.value.status){
            statusSubmit();
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      //添加优惠券
      const addSubmit = () =>{
        $Modal.confirm({
          centered:true,
          title:'确认生成优惠券？',
          content: '保存后部分数据将无法进行修改', 
          onOk(){
            confirmSubmit()
          }
        })
      }
      //编辑状态优惠券
      const statusSubmit = () =>{
        $Modal.confirm({
          centered: true,
          width: 500,
          title: '确定要使优惠券失效吗？',
          icon: createVNode(ExclamationCircleOutlined),
          content: h('div', {}, [
            h('p', { className: 'm-b-15' },'失效后，买家无法再领取该优惠券'),
            h('p',  '2、买家之前已领取到的优惠券，在有效期内还能继续使用。'),
          ]),
          onOk() { 
            confirmSubmit()
          }
        });
      }
      //提交请求
      const confirmSubmit = async() =>{
        let res
        const hide = message.loading('正在加载中...', 0);
        const products = _lodash.map(state.goodList, 'id')
        form.value.valid_starts_time = state.time[0] ? state.time[0] : ''
        form.value.valid_end_time = state.time[1] ? state.time[1] : ''
        if ($route.query.type == 'add') {
          res = await newCouponAdd({ ...form.value,products:JSON.stringify(products)}).then(res => res.data).catch(error => error);
        } else {
          res = await newCouponEdit({ ...form.value,id: $route.query.id,products:JSON.stringify(products)}).then(res => res.data).catch(error => error);
        }
        if (iscode(res)) {
          message.success(res.msg);
          setTimeout(() => {
            $router.go(-1)
          }, 2000);
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      onMounted(() => {
        
        if ($route.query.type == 'edit') {
          getMore($route.query.id);
        }else{
          form.value.coupon_type = $route.query.card
        }
      })
      
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        goodSelect,
        changDate,
        delGood,
        changeCondition,
        columns,
        disabledDate,
        isNumber,
        momentTime,
        testTime
      }
    }
  }
</script>
<style lang="less" scoped>
  .couponBox .coupon_one {
    border-bottom: 1px dashed #dedede;
    position: relative;
  }

  .couponBox .coupon_one .ban {
    width: 10px;
    height: 20px;
    background-color: #efefef;
    display: block;
    position: absolute;
    bottom: -10px;
    z-index: 1;
  }

  .couponBox .coupon_one .ban.right {
    right: -2px;
    -webkit-border-radius: 20px 0 0 20px;
    border-radius: 20px 0 0 20px;
  }

  .couponBox .coupon_one .ban.left {
    left: -2px;
    -webkit-border-radius: 0 20px 20px 0;
    border-radius: 0 20px 20px 0;
  }

  .couponBox:after {
    content: "";
    width: 100%;
    height: 4px;
    background: url('../../../../assets//images/ta.png') -9px 0 / auto 100%;
    position: absolute;
    top: -4px;
    left: 0;
  }

  .logo {
    border-radius: 100%;
    position: absolute;
    left: 50%;
    top: -25px;
    transform: translateX(-50%);
  }

  .coverBox {
    width: 274px;
    height: 107px;
    border: 1px dashed #ddd;
  }
</style>